module.exports = __webpack_public_path__ + "img/365.057bdb4b.png";